module.exports = __webpack_public_path__ + "static/media/CAM_HIL.c946c697.png";